

exports.__esModule = true;
exports["default"] = void 0;
var _angular = require("angular");
var _squid = require("squid");
var _index = require("xo-models/src/subscription/index");
var _autobillingTerms = _interopRequireDefault(require("../../autobilling-terms"));
var _template = _interopRequireDefault(require("./template"));
require("./styles.less");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = _squid.$Component.extend('$autobilling', {
  tag: 'autobilling',
  template: _template["default"],
  props: {
    baToken: {
      type: 'var',
      optional: false
    },
    merchantId: {
      type: 'var',
      optional: false
    }
  },
  resolve: {
    models: function models() {
      return {
        autobillingData: _index.$SubscriptionModel.instance(this.baToken).retrieve({
          params: {
            merchant_id: this.merchantId
          }
        })["catch"](_angular.noop)
      };
    }
  },
  lifecycle: {
    populate: function populate() {
      var _this = this;
      this.itemName = _autobillingTerms["default"].getItemName(this.models.autobillingData);
      this.itemOptions = _autobillingTerms["default"].getItemOptions(this.models.autobillingData);
      this.getTermsText = function () {
        return _autobillingTerms["default"].getTermsText(_this.models.autobillingData);
      };
    }
  }
});
_angular.noop;
_squid.$Component;
_index.$SubscriptionModel;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-page-components/src/cart/autobilling/directive.js
// module id = ../node_modules/xo-page-components/src/cart/autobilling/directive.js
// module chunks = 0